import request from "@/config/utils/request";

// 公用 请求OMC组织机构下的部门及人员（不包含子集单位及其人员）
export function getUnderOrg(obj) {
  return request({
    url: "/apis/ebs/org/listUnderOrg",
    method: "post",
    data: obj
  });
}

// import request from "@/config/utils/request";
// /* export function MaterialList (data) {
//   return request({
//     url: 'http://test1.iccec.cn:8080/rest/service/routing/nouser/qryMatSubCatalogService', // 后端接口
//     method: 'post',
//     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//     data
//   })
// } */

// // 公用 请求OMC组织结构树
// export function qryOmcOrgTree(data) {
//   return request({
//     url: "/apis/omc/member/org/qryOmcOrgTree", // omc 组织机构树
//     method: "post",
//     data
//   });
// }

// // 公用 请求OMC组织机构下的部门及人员（不包含子集单位及其人员）
// export function qryUnderOrg(obj) {
//   return request({
//     url: "/apis/locpc/org/listUnderOrg",
//     method: "post",
//     data: obj
//   });
// }

// // 公用 请求PMC组织结构树
// export function qryPmcOrgTree(data) {
//   return request({
//     url: "/apis/pmc/member/org/qryOrgTree", // pmc 组织机构树
//     method: "post",
//     data
//   });
// }

// // 公用 请求SMC组织机构树
// export function qrySmcOrgList(data) {
//   return request({
//     url: "/apis/omc/member/org/queryNormalInfoList", // pmc 组织机构树
//     method: "post",
//     data
//   });
// }

// // 公用 请求当前用户菜单
// export function getAuthMenuApi(data) {
//   return request({
//     url: "/apis/omc/member/app/getAuthMenu", // pmc 组织机构树
//     method: "post",
//     data
//   });
// }

// // 公用 请求字典表工作流专用
// export function getDictApi(data) {
//   // code  getDictApi ({code:""})
//   return request({
//     url: "/apis/omc/workflow/processDefine/getDict", // pmc 组织机构树
//     method: "post",
//     data
//   });
// }

// // 请求omc字典表
// export function qryDictByCodeApi(data) {
//   return request({
//     url: "/apis/omc/member/common/qryDictByCode", // pmc 组织机构树
//     method: "post",
//     data
//   });
// }
